<template>
  <div class="search-result">
    <div v-if="!noHr" class='hr-line-dashed'></div>
    <div class="row">
      <div class="col-xs-8">
        <div class="flex align-items-center gap-sm">
          <h3 class="m-b-none">
            <span v-if="job.canonical_name">{{ job.duplicate_name || 'Unknown' }}</span>
            <span v-if="job.canonical_name"> <i class="fa-solid fa-right-long text-gray-400 text-12"></i> </span>
            <span v-if="job.canonical_name">{{ job.canonical_name }}</span>
            <span v-else>{{ job.name }}</span>
          </h3>
          <span v-if="job.merge_type" class="label label-default font-normal">{{ job.merge_type }}</span>
        </div>
        <p class="search-type-label m-b-none">
          <span v-if="succeeded" class="text-success">
            <i class="fa-regular fa-circle-check"></i>
            Completed
          </span>
          <span v-else-if="failed" class="text-danger">
            <i class="fa-solid fa-circle-xmark"></i>
            Failed
          </span>
          <span v-else class="text-muted">
            <i class="fa-solid fa-circle-notch"></i>
            Processing
          </span>
          <span v-if="processedAt"> · {{ processedAt }}</span>
          <span v-else> · Created {{ createdAt }}</span>
        </p>
        <p v-if="failed && job.result" class="text-danger text-12 m-b-none m-t-xxs">
          {{ job.result }}
        </p>
      </div>
      <div class="col-xs-4">
        <div class="text-right">
          <a v-if="succeeded" :href="canonicalUrl" class="btn btn-default btn-xs">
            View merged record
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { urlHelperMixin } from './mixins/url_helper_mix';

export default {
  name: 'merge-job-result',
  props: {
    job: {
      type: Object,
      required: true
    },
    noHr: {
      type: Boolean,
      default: false
    },
  },
  mixins: [
      urlHelperMixin
  ],
  computed: {
    processedAt() {
      if (!this.job.processed_at) {
        return '';
      }

      return moment(this.job.processed_at)
          .format('M/D/YYYY, hh:mm a');
    },
    createdAt() {
      if (!this.job.created_at) {
        return '';
      }

      return moment(this.job.created_at)
          .format('M/D/YYYY, hh:mm a');
    },
    canonicalUrl() {
      return this.urlForProfile(this.job.canonical_id, this.job.canonical_type)
    },
    succeeded() {
      return this.job.status === "ready";
    },
    failed() {
      return this.job.status === "failed";
    },
  }
};
</script>
